import { render, staticRenderFns } from "./InssInformation.vue?vue&type=template&id=8ba53562&scoped=true"
import script from "./InssInformation.vue?vue&type=script&lang=js"
export * from "./InssInformation.vue?vue&type=script&lang=js"
import style0 from "./InssInformation.vue?vue&type=style&index=0&id=8ba53562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba53562",
  null
  
)

export default component.exports